// http://dmfrancisco.github.io/react-icons/

import React from 'react'

const renderGraphic = icon => {
  switch (icon) {
    case 'keyboard-arrow-down':
      return (
        <g>
          <path d="M7.41 7.84l4.59 4.58 4.59-4.58 1.41 1.41-6 6-6-6z" />
        </g>
      )
    case 'keyboard-arrow-right':
      return (
        <g>
          <path d="M8.59 16.34l4.58-4.59-4.58-4.59 1.41-1.41 6 6-6 6z" />
        </g>
      )
    case 'remove':
      return (
        <g transform="scale(0.039)">
          <path d="m587.83 186.97c-16.116-37.332-37.944-69.768-65.484-97.308s-59.976-49.368-97.308-65.484-77.01-24.174-119.03-24.174c-28.152 0-55.284 3.672-81.396 11.016s-50.49 17.646-73.134 30.906-43.248 29.172-61.812 47.736-34.476 39.168-47.736 61.812c-13.26 22.646-23.562 47.022-30.906 73.134s-11.016 53.244-11.016 81.396 3.672 55.284 11.016 81.396c7.344 26.11 17.646 50.487 30.906 73.134 13.26 22.644 29.172 43.249 47.736 61.812 18.564 18.564 39.168 34.478 61.812 47.736 22.644 13.26 47.022 23.561 73.134 30.906 26.112 7.344 53.244 11.016 81.396 11.016s55.284-3.672 81.396-11.016c26.111-7.346 50.488-17.646 73.135-30.906 22.644-13.259 43.249-29.172 61.812-47.736 18.564-18.563 34.478-39.168 47.736-61.812 13.26-22.646 23.561-47.023 30.906-73.135 7.343-26.111 11.015-53.243 11.015-81.395 0-42.024-8.058-81.702-24.174-119.03zm-119.65 204.71c2.04 2.04 3.063 4.284 3.063 6.732s-1.021 4.488-3.063 6.12l-59.976 60.588c-1.631 1.632-3.876 2.448-6.732 2.448-2.854 0-4.895-0.816-6.12-2.448l-86.292-86.292-85.68 86.292c-2.448 1.632-4.692 2.448-6.732 2.448-1.632 0-3.672-0.816-6.12-2.448l-59.976-60.588c-2.04-1.226-3.06-3.267-3.06-6.12 0-2.448 1.02-4.692 3.06-6.732l85.68-85.68-85.68-85.68c-2.04-2.04-3.06-4.284-3.06-6.732 0-2.856 1.02-4.896 3.06-6.12l59.976-60.588c1.632-1.632 3.672-2.448 6.12-2.448s4.692 0.816 6.732 2.448l85.68 86.292 86.292-86.292c1.635-1.632 3.675-2.448 6.12-2.448 2.448 0 4.692 0.816 6.732 2.448l59.976 60.588c2.04 1.632 3.063 3.672 3.063 6.12s-1.021 4.692-3.063 6.732l-85.68 85.68 85.68 85.68z" />
        </g>
      )
    case 'search':
      return (
        <g
          transform="scale(0.02 -0.02)"
          style={{ transformOrigin: '24px 24px' }}
        >
          <path
            transform="translate(-1000 200)"
            d="M640 192c-209.92 0-384 174.080-384 384s174.080 384 384 384 384-174.080 384-384-174.080-384-384-384zM640 857.6c-153.6 0-281.6-128-281.6-281.6s128-281.6 281.6-281.6c153.6 0 281.6 128 281.6 281.6s-128 281.6-281.6 281.6zM371.855 379.939l72.407-72.407-358.415-358.415-72.407 72.407 358.415 358.415zM102.4-12.8c0-28.277-22.923-51.2-51.2-51.2s-51.2 22.923-51.2 51.2c0 28.277 22.923 51.2 51.2 51.2s51.2-22.923 51.2-51.2z"
          />
        </g>
      )
    case 'time':
      return (
        <g>
          <path d="M12,0a11.64,11.64,0,0,1,6,1.62A12.1,12.1,0,0,1,22.38,6,11.64,11.64,0,0,1,24,12a11.64,11.64,0,0,1-1.62,6A12.1,12.1,0,0,1,18,22.38,11.64,11.64,0,0,1,12,24a11.64,11.64,0,0,1-6-1.62A12.1,12.1,0,0,1,1.62,18,11.64,11.64,0,0,1,0,12,11.64,11.64,0,0,1,1.62,6,12.1,12.1,0,0,1,6,1.62,11.64,11.64,0,0,1,12,0Zm0,22.53a10.15,10.15,0,0,0,5.26-1.42,10.61,10.61,0,0,0,3.85-3.85A10.15,10.15,0,0,0,22.53,12a10.15,10.15,0,0,0-1.42-5.26,10.61,10.61,0,0,0-3.85-3.85A10.15,10.15,0,0,0,12,1.47,10.15,10.15,0,0,0,6.74,2.89,10.61,10.61,0,0,0,2.89,6.74,10.15,10.15,0,0,0,1.47,12a10.15,10.15,0,0,0,1.42,5.26,10.61,10.61,0,0,0,3.85,3.85A10.15,10.15,0,0,0,12,22.53Zm3-5.88a.56.56,0,0,0,.44.09.58.58,0,0,0,.38-.24l.87-1.26a.56.56,0,0,0,.12-.43.51.51,0,0,0-.21-.39L13.35,12.1V5.23a.55.55,0,0,0-.58-.58H11.23a.55.55,0,0,0-.58.58v7.93a.62.62,0,0,0,.24.49Z" />
        </g>
      )
    case 'education':
      return (
        <g>
          <path d="M11.9,4l-.12,0L.45,8.21A.71.71,0,0,0,0,9.1a.67.67,0,0,0,.41.43l4.22,1.55v6a1.84,1.84,0,0,0,.78,1.42,5.13,5.13,0,0,0,1.62.82A15.89,15.89,0,0,0,12,20a15.85,15.85,0,0,0,4.93-.7,5.13,5.13,0,0,0,1.62-.82,1.84,1.84,0,0,0,.78-1.42v-6l3.34-1.23v3.54a.67.67,0,1,0,1.33,0V8.87a.71.71,0,0,0-.45-.66L12.22,4A.59.59,0,0,0,11.9,4ZM12,5.43l9.32,3.43L12,12.31,2.67,8.87ZM6,11.57l5.78,2.13a.66.66,0,0,0,.44,0L18,11.57v5.49s0,.13-.26.32a4.11,4.11,0,0,1-1.23.6,14.94,14.94,0,0,1-4.51.63A14.94,14.94,0,0,1,7.49,18a4.24,4.24,0,0,1-1.23-.6C6,17.19,6,17.08,6,17.06Z" />
        </g>
      )
    case 'heart-fill':
      return (
        <path
          transform="scale(0.97)"
          d="M20.94,14l-8.35,7.82a.87.87,0,0,1-1.18,0L3.05,13.93c-.11-.09-3-2.71-3-5.84C0,4.28,2.39,2,6.4,2,8.74,2,10.94,3.8,12,4.81,13.06,3.8,15.26,2,17.6,2c4,0,6.4,2.28,6.4,6.09C24,11.22,21.06,13.84,20.94,14Z"
        />
      )
    case 'heart-outline':
      return (
        <path
          transform="scale(0.97)"
          d="M20.94,14l-8.35,7.82a.87.87,0,0,1-1.18,0L3.05,13.93c-.11-.09-3-2.71-3-5.84C0,4.28,2.39,2,6.4,2,8.74,2,10.94,3.8,12,4.81,13.06,3.8,15.26,2,17.6,2c4,0,6.4,2.28,6.4,6.09C24,11.22,21.06,13.84,20.94,14ZM17.6,3.67c-2,0-4.25,2.09-4.94,2.9a.91.91,0,0,1-1.32,0c-.69-.81-2.94-2.9-4.94-2.9s-4.69.76-4.69,4.42c0,2.39,2.48,4.6,2.51,4.63L12,20l7.77-7.28s2.52-2.25,2.52-4.64C22.29,4.43,19.74,3.67,17.6,3.67Z"
        />
      )
    case 'location':
      return (
        <path d="M12,0A8.12,8.12,0,0,0,3.79,8c0,2.24,1,4.92,2.47,7.69a58.47,58.47,0,0,0,5.19,8,.69.69,0,0,0,1,.12.81.81,0,0,0,.14-.12,58.47,58.47,0,0,0,5.19-8c1.45-2.77,2.47-5.45,2.47-7.69A8.12,8.12,0,0,0,12,0m0,1.33A6.75,6.75,0,0,1,18.84,8c0,1.82-.92,4.4-2.32,7.09A54.64,54.64,0,0,1,12,22.17,54.64,54.64,0,0,1,7.48,15.1C6.08,12.41,5.16,9.83,5.16,8A6.75,6.75,0,0,1,12,1.33m0,2A4.74,4.74,0,0,0,7.21,8a4.79,4.79,0,0,0,9.58,0A4.74,4.74,0,0,0,12,3.33m0,1.34A3.34,3.34,0,1,1,8.58,8,3.36,3.36,0,0,1,12,4.67" />
      )
    case 'date':
      return (
        <path d="M20.64,3.16a2.26,2.26,0,0,1,1.67.69A2.29,2.29,0,0,1,23,5.53v16.1A2.36,2.36,0,0,1,20.64,24H3.36A2.36,2.36,0,0,1,1,21.63V5.53a2.29,2.29,0,0,1,.69-1.68,2.26,2.26,0,0,1,1.67-.69H5.71V.59A.58.58,0,0,1,5.89.17.57.57,0,0,1,6.3,0h2a.61.61,0,0,1,.42.17.61.61,0,0,1,.17.42V3.16h6.28V.59a.61.61,0,0,1,.17-.42A.61.61,0,0,1,15.73,0h2a.57.57,0,0,1,.41.17.58.58,0,0,1,.18.42V3.16Zm.47,19.16a.29.29,0,0,0,.21-.1.35.35,0,0,0,.11-.22l0-14.82L2.57,7.2,2.59,22a.29.29,0,0,0,.1.21.31.31,0,0,0,.22.11Z" />
      )
    case 'check':
      return (
        <g>
          <rect
            rx="0.5"
            ry="0.5"
            transform="rotate(44.90227508544922 5.937499999999995,15.437500953674318) "
            height="3.491488"
            width="11.989272"
            y="13.691756"
            x="-0.057136"
            fill="inherit"
          />
          <rect
            rx="0.5"
            ry="0.5"
            transform="rotate(44.90227508544922 15.088073730468746,12.32894325256348) "
            height="20.813924"
            width="3.415012"
            y="1.921981"
            x="13.380568"
            fill="inherit"
          />
        </g>
      )
    case 'square':
      return (
        <g>
          <rect x="5" y="5" width="12" height="12" fill="inherit"/>
        </g>
      )
    case 'star' :
      return (
        <g>
          <path d="M0 0h24v24H0z" fill="none"/><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
        </g>
      )
    default:
      return null
  }
}

const styles = size => ({
  fill: 'currentColor',
  verticalAlign: 'middle',
  width: size,
  height: size
})

export default ({ icon, size, style, active, is, ...rest }) => (
  <svg
    viewBox="0 0 24 24"
    preserveAspectRatio="xMidYMid meet"
    style={{ ...styles(size ? size : 24), ...style }}
    {...rest}
  >
    {renderGraphic(icon)}
  </svg>
)
